import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

const styles = {
  listItemButton: {
    "&.Mui-selected": {
      "& .MuiListItemText-primary": {
        color: "primary.main",
      },
    },
  },
};

export default function BillingConfigurationSidebar({
  items = [],
  selectedId,
  onSelect,
  onAddCostCenter,
  readOnly = false,
}) {
  return (
    <Box>
      <Paper sx={{ ml: 2, width: 220 }}>
        <List disablePadding>
          {items.map(item => (
            <ListItemButton
              key={item.id}
              selected={item.id === selectedId}
              onClick={() => onSelect(item.id)}
              sx={styles.listItemButton}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
        {onAddCostCenter && !readOnly && (
          <Box px={1.5} pb={1.5} mt={1}>
            <Button
              onClick={onAddCostCenter}
              size="small"
              variant="outlined"
              fullWidth
              startIcon={<AddIcon />}
            >
              Add Cost Center
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
}
